import { useState } from "react";
import { useStore, CAT_META } from "../store/Store";

// ─── TAG CARD ─────────────────────────────────────────────────────────────────
// Used for "Premium Picks". Full-bleed photo with a dark gradient scrim and
// white text sitting directly on the image, magazine-cover style — moodier
// and more editorial than the other carousel styles, on purpose.
export default function TagCard({ p, onNav, accent }) {
  const { dispatch, wish, toggleWish, notify } = useStore();
  const [hovered, setHovered] = useState(false);
  const meta = CAT_META[p.category] || { emoji:"👗" };
  const disc = Math.round((1 - p.price / p.mrp) * 100);
  const wished = wish.includes(p.id);

  const addCart = (e) => {
    e.stopPropagation();
    dispatch({ type:"ADD", p:{ ...p, sc:p.colors?.[0]||"Default", ss:p.sizes?.[0]||"Free" } });
    notify(`${p.name} added!`);
    if (navigator.vibrate) navigator.vibrate(50);
  };

  return (
    <div
      onClick={()=>onNav("product", p.id)}
      onMouseEnter={()=>setHovered(true)}
      onMouseLeave={()=>setHovered(false)}
      style={{
        borderRadius:18, overflow:"hidden", cursor:"pointer", position:"relative",
        height:380, background:"#1a1a2e",
        boxShadow: hovered ? "0 24px 48px rgba(0,0,0,0.35)" : "0 8px 24px rgba(0,0,0,0.2)",
        transform: hovered ? "translateY(-6px)" : "translateY(0)",
        transition:"all 0.4s ease",
      }}>
      {p.img
        ? <img src={p.img} alt={p.name} style={{ position:"absolute", inset:0, width:"100%", height:"100%", objectFit:"cover", objectPosition:"top", transition:"transform 0.6s ease", transform:hovered?"scale(1.08)":"scale(1)" }} loading="lazy"/>
        : <div style={{ position:"absolute", inset:0, background:meta.light||"#333", display:"flex", alignItems:"center", justifyContent:"center", fontSize:64, opacity:0.3 }}>{meta.emoji}</div>
      }

      {/* Dark scrim gradient for text legibility */}
      <div style={{ position:"absolute", inset:0, background:"linear-gradient(to bottom, rgba(0,0,0,0.15) 0%, transparent 30%, transparent 50%, rgba(0,0,0,0.88) 100%)" }}/>

      {/* Corner ribbon */}
      <div style={{ position:"absolute", top:16, left:16, background:accent, color:"white", fontSize:9, fontWeight:800, letterSpacing:1.5, padding:"5px 12px", borderRadius:20, textTransform:"uppercase" }}>
        ✦ Premium
      </div>
      {disc > 0 && (
        <span style={{ position:"absolute", top:16, right:16, background:"white", color:"#1a1a2e", fontSize:10, fontWeight:800, padding:"4px 10px", borderRadius:20 }}>
          {disc}% OFF
        </span>
      )}
      <button onClick={e=>{ e.stopPropagation(); toggleWish(p.id); if(navigator.vibrate)navigator.vibrate(30); }}
        style={{ position:"absolute", bottom:100, right:16, background:"rgba(255,255,255,0.9)", border:"none", borderRadius:"50%", width:30, height:30, fontSize:14, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center" }}>
        {wished ? "❤️" : "🤍"}
      </button>

      {/* Bottom text on the photo */}
      <div style={{ position:"absolute", bottom:0, left:0, right:0, padding:"18px 18px 20px" }}>
        <div style={{ fontSize:9, color:"rgba(255,255,255,0.7)", letterSpacing:2, textTransform:"uppercase", marginBottom:5 }}>{p.category}</div>
        <div style={{ fontFamily:"'Playfair Display',serif", fontSize:18, fontWeight:800, color:"white", marginBottom:10, lineHeight:1.25 }}>{p.name}</div>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", gap:10 }}>
          <div>
            <span style={{ fontSize:17, fontWeight:900, color:"white" }}>₹{p.price?.toLocaleString("en-IN")}</span>
            {p.mrp > p.price && <span style={{ fontSize:11, color:"rgba(255,255,255,0.55)", textDecoration:"line-through", marginLeft:6 }}>₹{p.mrp?.toLocaleString("en-IN")}</span>}
          </div>
          {p.stock > 0 ? (
            <button onClick={addCart} style={{ background:"white", color:"#1a1a2e", border:"none", padding:"8px 16px", borderRadius:20, fontSize:11, fontWeight:800, cursor:"pointer" }}>
              + Add
            </button>
          ) : (
            <span style={{ fontSize:10, fontWeight:700, color:"#F87171" }}>Out of Stock</span>
          )}
        </div>
      </div>
    </div>
  );
}
